import { IPersmissions } from "../models/auth.interface";
import { SET_PERMISSIONS } from "../actions/auth.actions";

const initialState: IPersmissions = {
    isAuth: "1",
    is_auth:"1",


};

function authReducer(state: IPersmissions = initialState, action: any){
    switch(action.type){
        case SET_PERMISSIONS:

            return {...state, ...action.payload};
        default:
            return {...state};
    };
};

export default authReducer;